<template>
    <div class="">
        {{ alert.name }} <br>
        <small>{{ alert.message }}</small>
        <div class="dismiss">
            <span
                v-loading="isLoading"
                @click="dismiss(alert)"
            >
                {{ $store.getters['fundation/getVerbose']('alert_dismiss') }}
            </span>
        </div>
    </div>
</template>

<script>

export default {
    components: {

    },

    props: {
        alert: {
            type: Object,
            required: true,
        },
    },

    data: function(){
        return {
            isLoading: false,
        };
    },

    computed: {

    },

    mounted: function(){

    },

    methods: {
        dismiss() {
            this.isLoading = true;
            this.$store.dispatch('patchItem', {
                item: {
                    uid: this.alert.uid,
                    acquited: true,
                    url: this.alert.url
                },
                model: 'alerts',
            }).then(() => {
                this.isLoading = false;
            });
        },
    },
};
</script>

<style lang="less" module>

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/layouts/dashboard/Alert.vue